import { useEffect, useRef, useState } from "react";
// import "./NewVendor.css";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import moment from "moment";
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  InputGroup,
  Form,
} from "react-bootstrap";
import {
  IconUserCheck,
  IconUserOff,
  IconTrash,
  IconBuildingBank,
  IconEye,
  IconEdit,
  IconPaperclip,
  IconMessageCircle,
  IconCreditCard,
  IconSearch,
  IconBox,
  IconLayoutListFilled,
  IconLayoutGridFilled,
  IconPencil,
  IconChevronRight,
  IconDotsVertical,
} from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import { toast } from "react-toastify";
import CustomerCard from "./CustomerCard";
import View_DetailsProduct from "./ViewDetail/View_DetailsCustomer";
import { useSelector } from "react-redux";
import useIdleLogout from "../../hooks/useIdleLogout";
import ContactList from "./ContactList";

const CustomerListUI = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [isListView, setIsListView] = useState(true);
  const [customerData, setCustomerData] = useState([]);
  const [hasMoreCustomers, setHasMoreCustomers] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (id) => {
    const isOpening = openDropdown !== id;
    setOpenDropdown(isOpening ? id : null);
    if (tableWrapperRefs.row1?.current) {
      tableWrapperRefs.row1.current.style.overflow = isOpening
        ? "visible"
        : "auto";
    }
  };

  const navigate = useNavigate();
  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    order: [],
    isStatusUpdate: false,
  });
  const [isCardOpen, setIsCardOpen] = useState({
    show: false,
    auto_id: null,
    primary_email: null,
  });

  const handleCloseCard = () => {
    setIsCardOpen({ show: false, auto_id: null, primary_email: null });
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    user: null,
    message: "",
  });

  useIdleLogout();

  const {
    data: customers,
    isLoading: loadingCustomers,
    postData: fetchCustomers,
  } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER);

  const { isLoading, postData: updateCustomerStatus } = usePostRequest(
    API_ENDPOINTS.CUSTOMER_STATUS_UPDATE,
  );

  const onSuccessfulFetchCustomers = (response, reset = false) => {
    if (!response?.data || response.data.length < limit) {
      setHasMoreCustomers(false);
    } else {
      setHasMoreCustomers(true);
    }
    setCustomerData((prevData) => {
      const combined = reset
        ? response?.data || []
        : [...prevData, ...(response?.data || [])];
      const unique = Array.from(
        new Map(combined.map((item) => [item.auto_id, item])).values(),
      );
      return unique;
    });
  };

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };
  const onStatusError = (error) => {
    toast.error(error.message || "An error occurred during deactivation.");
  };

  const handleViewClick = (customer) => {
    handleClickOutside();
    setIsViewOpen({
      show: true,
      products: customer,
      auto_id: customer.auto_id,
    });

    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${customer.auto_id}`;
    window.history.pushState(null, "", newUrl);
  };

  const handleActivateCustomer = (user) => {
    updateCustomerStatus(
      {
        active: true,
        auto_id: user.auto_id,
      },
      onStatusSuccess,
      onStatusError,
    );
    setIsModalOpen({ ...isModalOpen, show: false });
  };

  useEffect(() => {
    fetchCustomers(
      {
        page,
        limit,
        search: searchTerm || null,
      },
      (response) => onSuccessfulFetchCustomers(response, page === 1),
    );
  }, [page, limit, isSearchClicked]);

  const handleLoadMore = () => {
    if (hasMoreCustomers && !loadingCustomers) {
      setPage((prev) => prev + 1);
    }
  };

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    setPage(1);
    setCustomerData([]);
    setHasMoreCustomers(true);
    setIsSearchClicked((prev) => !prev);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setPage(1);
    setCustomerData([]);
    setHasMoreCustomers(true);
    setIsSearchClicked((prev) => !prev);
  };

  const handleDeactivateCustomer = (user) => {
    if (user.balance > 0) {
      toast.error(
        "This Customer can't be Inactive because it has a non-zero balance.",
      );
      return;
    }
    updateCustomerStatus(
      {
        active: false,
        auto_id: user.auto_id,
      },
      onStatusSuccess,
      onStatusError,
    );

    setIsModalOpen({ ...isModalOpen, show: false });
  };

  const openModal = (action, user) => {
    let modalMessage = "";
    let modalTitle = "";
    let type = "";
    let modalIcon = null;
    let actionHandler = () => { };

    if (action === "delete") {
      type = "danger";
      modalMessage = "Are you sure you want to delete this customer?";
      modalTitle = "Delete Customer";
      modalIcon = <IconTrash />;
    } else if (action === "activate") {
      type = "warning";
      modalMessage = "Are you sure you want to activate this customer?";
      modalTitle = "Activate Customer";
      modalIcon = <IconUserCheck />;
      actionHandler = () => handleActivateCustomer(user);
    } else if (action === "deactivate") {
      type = "warning";
      modalMessage = "Are you sure you want to deactivate this customer?";
      modalTitle = "Deactivate Customer";
      modalIcon = <IconUserOff />;
      actionHandler = () => handleDeactivateCustomer(user);
    }

    setIsModalOpen({
      show: true,
      action,
      user,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  function safeGet(objOrStr, key) {
    try {
      const value =
        typeof objOrStr === "string" ? JSON.parse(objOrStr) : objOrStr;
      return value?.[key] || "N/A";
    } catch {
      return "N/A";
    }
  }

  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");
  const canViewCards = user?.permissions?.manage_cards?.includes("read");

  const searchInputRef = useRef();
  const tableWrapperRefs = {
    row1: useRef(null),
    row2: useRef(null),
    row3: useRef(null),
    row4: useRef(null),
    row5: useRef(null),
    row6: useRef(null),
  };
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event?.target)) {
      setOpenDropdown(null);
      if (tableWrapperRefs.row1?.current) {
        tableWrapperRefs.row1.current.style.overflow = "auto";
      }
    }
  };
  useEffect(() => {
    if (!openDropdown) return;
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [openDropdown]);

  return (
    <>
      <View_DetailsProduct
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
      />
      {isCardOpen.show && (
        <CustomerCard
          show={isCardOpen.show}
          setShow={handleCloseCard}
          auto_id={isCardOpen.auto_id}
          primary_email={isCardOpen.primary_email}
        />
      )}
      {isListView ? (
        <div className="page-header d-print-none">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Customer Management</h2>
            </div>
          </div>
        </div>
      ) : null}

      {isListView ? (
        <Card className="mb-3">
          <CardBody>
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSearch();
                }
              }}
            >
              <Row className="align-items-end">
                <Col md={9}>
                  <Form.Label>Search Customer</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>
                      <IconSearch />
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={handleSearchInputChange}
                    />
                  </InputGroup>
                </Col>
                <Col md={3}>
                  <div className="d-flex gap-2">
                    <Button
                      className="w-100"
                      variant="warning"
                      onClick={handleSearch}
                    >
                      Apply Filters
                    </Button>
                    <Button
                      className="w-100"
                      variant="outline-secondary"
                      onClick={handleClearSearch}
                    >
                      Clear Filters
                    </Button>
                  </div>
                </Col>
                <Form.Text>
                  Search by Customer's name, Person's name, or any other
                  relevant keyword.
                </Form.Text>
              </Row>
            </Form>
          </CardBody>
        </Card>
      ) : null}
      {isListView ? (
        <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
          <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
            <IconLayoutGridFilled
              onClick={() => setIsListView(false)}
              style={{
                cursor: "pointer",
                color: !isListView ? "#FE6338" : "#515151",
              }}
            />
            <IconLayoutListFilled
              onClick={() => setIsListView(true)}
              style={{
                cursor: "pointer",
                color: isListView ? "#FE6338" : "#515151",
              }}
            />
          </div>
        </div>
      ) : null}

      {isListView ? (
        <div className="order_list_view">
          <div
            className="table-responsive mail_wrapper border-0 p-0"
            ref={tableWrapperRefs.row1}
            style={{ overflowX: "auto" }}
          >
            <table className="table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Person's Name</th>
                  <th>Contact Name</th>
                  <th>Phone Number</th>
                  <th>Created Date</th>
                  <th>Email Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {customerData.length > 0 ? (
                  customerData.map((row, index) => {
                    return (
                      <tr key={index}>
                        <td>{row?.type || "N/A"}</td>
                        <td>{row?.display_name || "N/A"}</td>
                        <td>
                          {row?.first_name || row?.last_name
                            ? `${row.first_name || ""} ${row.last_name || ""
                              }`.trim()
                            : "N/A"}
                        </td>
                        <td>
                          {safeGet(row?.primary_phone, "FreeFormNumber")}
                        </td>
                        <td>{moment(row?.createdAt).format("MM/DD/YYYY")}</td>
                        <td style={{ textTransform: "lowercase" }}>
                          {safeGet(row?.primary_email, "Address")}
                        </td>
                        <td style={{ position: "relative" }}>
                          <button
                            onClick={() => toggleDropdown(row.auto_id)}
                            style={{
                              background: "transparent",
                              border: "none",
                              cursor: "pointer",
                            }}
                          >
                            <IconDotsVertical size={20} />
                          </button>
                          {openDropdown === row.auto_id && (
                            <ul
                              ref={dropdownRef}
                              className="order-dropdown-menu p-0"
                            >
                              <li
                                className="dropdown-item"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/customer-edit/${row?.auto_id}`);
                                }}
                              >
                                <span>
                                  <IconPencil stroke={1} /> Edit
                                </span>
                                <IconChevronRight stroke={1} />
                              </li>
                              <li
                                className="dropdown-item border-top"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleViewClick(row);
                                }}
                              >
                                <span>
                                  <IconEye stroke={1} /> View Details
                                </span>
                                <IconChevronRight stroke={1} />
                              </li>
                              <li
                                className="dropdown-item border-top"
                                style={{
                                  cursor: !canViewCards
                                    ? "not-allowed"
                                    : "auto",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleClickOutside();
                                  if (canViewCards) {
                                    setIsCardOpen({
                                      show: true,
                                      auto_id: row.auto_id,
                                      primary_email: row.primary_email,
                                    });
                                  }
                                }}
                              >
                                <span>
                                  <IconBuildingBank stroke={1} /> Payment
                                  Details
                                </span>
                                <IconChevronRight stroke={1} />
                              </li>
                              <li className="border-top">
                                <div className="rfq_lis_short justify-content-center p-2">
                                  <span>
                                    <IconCreditCard stroke={1} />{" "}
                                    {row.detailsCount ?? 0}
                                  </span>
                                  <span>
                                    <IconPaperclip stroke={1} />{" "}
                                    {row.Attachments?.length ?? 0}
                                  </span>
                                  <span>
                                    <IconMessageCircle stroke={1} />{" "}
                                    {row.section.reduce((acc, section) => {
                                      return acc + section.notes.length;
                                    }, 0)}
                                  </span>
                                </div>
                              </li>
                            </ul>
                          )}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {customerData.length >= 10 && hasMoreCustomers && (
              <div className="text-center mt-3">
                <Button
                  variant="outline-primary"
                  onClick={handleLoadMore}
                  disabled={loadingCustomers}
                >
                  {loadingCustomers ? "Loading..." : "Load More"}
                </Button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <ContactList />
      )}
      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />
    </>
  );
};

export default CustomerListUI;